import React, { useEffect, useContext, useState } from 'react'
import {
    UserContext,
    apiUrl
  } from '@dialectic-design/hyperobjects-user-context'
import {
    DataTable
} from "@dialectic-design/hyperobjects-entity-context"
import "@dialectic-design/hyperobjects-entity-context/dist/index.css"
import {
    Button,
    Divider
} from "semantic-ui-react"
import day from "dayjs"
import { useHistory } from "react-router-dom";

const ScriptsList = () => {
    const user = useContext(UserContext)
    const [scripts, setScripts] = useState(false)
    const history = useHistory()
    useEffect(() => {
        if(scripts === false) {
            fetch(apiUrl + '/admin/scripts', {
                headers: {
                    'Authorization': `Bearer ${user.token}`
                },
                credentials: 'include'
            }).then(resp => {
                resp.json().then(data => {
                    console.log(data)
                    setScripts(data)
                })
            })
        }
    })
    return (
        <div className='scripts-list'>
            {scripts && (
                <React.Fragment>
                <h2>Scripts</h2>
                <Button
                    href={`data:text/json;charset=utf-8,${encodeURIComponent(
                        JSON.stringify(scripts)
                      )}`}
                      download={`all-scripts-${day().format("YYYY-MM-DDTHH:mm")}.json`}
                    >
                    Download all
                </Button>
                <Button
                    floated="right"
                    onPointerDown={() => {
                        history.push("/new-script")
                    }}
                    >
                    New script
                </Button>
                <Divider />
                <DataTable
                    data={scripts}
                    columns={[
                        "name",
                        "updatedAt",
                        "createdAt",
                        "_id"
                    ]}
                    search={true}
                    link={(row) => `/script/${row._id}`}
                    />
                </React.Fragment>
            )}
            
        </div>
    )
}

export default ScriptsList